import React from 'react';

import { NavLink } from 'react-router-dom';

import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';

import NewContactForm from '@app/components/UI/ContactForm/NewContactForm';

import '@app/scss/pages/services.scss';
import ScrollSection from '@app/components/UI/ScrollSection';
import SimpleScroll from '@app/components/UI/SimpleScroll/SimpleScroll';

const list = [
	{
		title: 'ONLINE DMV SERVICES',
		description: <>
			New tag and title, transfer of registration, title transfer, title only, duplicates, modifications,
			corrections, renewals, and other services directly from our online portal
		</>,
		img: '/images/50_states_dmv_services.jpg'
	},
	{
		title: 'Fee Quotes',
		description: 'Automated online fee quotes at the point of sale. On demand fee quotes in every state,' +
			' county, and zip code in the country; calculating the sales price, applicable aftermarket,' +
			' and trade-in allowance for your customers',
		img: '/images/free_quotes.jpg'
	},
	{
		title: 'DMS INTEGRATION',
		description: <>
			No more manual entries of data, save time loading deals from your DMS with the least amount of work
			and the least amount of mistakes
		</>,
		img: '/images/dms_integration.jpg'
	},
	{
		title: 'NMVITIS',
		description: 'National Motor Vehicle Title Information System (NMVTIS), lookup Accidents & Registration Vehicle History.',
		img: '/images/NMVITIS.jpg'
	},
	{
		title: 'DEALER TRAINING',
		description: 'We provide your staff with comprehensive ongoing training as needed from the point of sale,' +
			' finance, title clerks and back office',
		img: '/images/dealer_training.jpg'
	},
	{
		title: 'LIVE SUPPORT',
		description: 'Our dedicated title clerks are available to provide live customer support',
		img: '/images/customer_support.jpg'
	}
];

const Services: React.FC = () => {
	return (
		<div className="services">
			<div className="services__section container" style={{minHeight: '100vh'}}>
				<div className="perspective" style={{marginTop: 20}}>
					<h1 className="contact-us__title hero-text hero">
						Our <span className="clipped">Servic</span>es
					</h1>
				</div>
				<div className="perspective">
					<h4 className="fade-in-slow-on-view">
						We offer customers and auto dealers in all 50 states smooth, efficient services related to title and registration.
						With 30 years of <strong>COMBINED</strong> expertise, our services stand out for their exceptional client service, instant fee
						estimates, user-friendly platform, and easy, straightforward process.
					</h4>
				</div>
				<SimpleScroll/>
			</div>
			<ScrollSection
				text={<>
					As the industry's fastest-growing agency, we offer customers and auto dealers in all 50 states smooth and efficient DMV
					services related to title and registration. Our exceptional client service and easy, straightforward process set our services
					apart, backed by 30 years of <strong>Combined</strong> expertise. Service your transaction or request a demo of our platform 
					today!
				</>}
				button={<NavLink to="/contact-us" className="primary-button-2 w-inline-block">
					<div className="wrapper-2">
						<div className="primary-button-text">Demo Now</div>
					</div>
					<div className="primary-button-shadow-2"/>
				</NavLink>}
			/>
			<div style={{paddingRight: '5%', paddingLeft: '5%'}}>
				<div className="container-large" id="services-seemore" style={{scrollMarginTop: '90px'}}>
					<h2 className="card-list-title">
						NATIONWIDE DMV SOLUTIONS
					</h2>
					<div className="card-list">
						{list.map(({title, description, img}, i) => <div key={i} className="card-wrapper">
							<div className="card">
								<div className="card-img">
									<ImageLazy alt={title} src={img}/>
								</div>
								<div className="card-info">
									<h3 className="card-title">
										{title}
									</h3>
									<p className="card-description">
										{description}
									</p>
								</div>
							</div>
						</div>)}
					</div>
				</div>
			</div>
			<NewContactForm title="Need help?"/>
		</div>
	);
};

export default Services;
